import config from "@/config"
import http from "@/utils/request"

export default {
	list: {
		url: `${config.API_URL}/alarmList/`,
		name: "获取报警记录",
		get: async function(data){
			return await http.get(this.url, data);
		}
	},
	deviceAlarm:{
		url: `${config.API_URL}/deviceAlarm/`,
		name: "获取设备的报警记录",
		get: async function(id,data){
			return await http.get(this.url+id+'/', data);
		}
	},
    update: {
		url: `${config.API_URL}/deviceAlarm/`,
		name: "确认报警记录",
		patch: async function(id,data){
			return await http.patch(this.url+id+'/', data);
		}
	},
	alarmReason:{
		url: `${config.API_URL}/alarmType/`,
		name: "报警原因",
		get: async function(data){
			return await http.get(this.url+'/', data);
		}
	},
	untreated:{
		url: `${config.API_URL}/userDeviceAlarmLog`,
		name: "未处理报警",
		get: async function(data){
			return await http.get(this.url, data);
		}
	},
	deviceAlarmRecord:{
		url: `${config.API_URL}/deviceAlarmRecord`,
		name: "查询所有报警记录",
		get: async function(data){
			return await http.get(this.url, data);
		}
	},
	deviceTestRecord:{
		url: `${config.API_URL}/deviceAlarmRecord/keyTest`,
		name: "查询所有报警测试记录",
		get: async function(data){
			return await http.get(this.url, data);
		}
	},
	exportTestRecordArray:{
		url: `${config.API_URL}/deviceAlarmRecord/keyTest/export`,
		name: "导出选择的报警测试记录",
		post: async function(data){
			return await http.post(this.url, data);
		}
	},
	exportTestRecordAll:{
		url: `${config.API_URL}/deviceAlarmRecord/keyTest/all/export`,
		name: "导出所有报警测试记录",
		post: async function(data){
			return await http.post(this.url, data);
		}
	},
	/** 报警记录页「全部导出」 */
	exportAllAlarmRecords: {
		url: `${config.API_URL}/alarmRecords/export/allAlarmRecords`,
		name: "导出全部报警记录",
		post: async function(data){
			return await http.post(this.url, data);
		}
	},
    // delete: {
	// 	url: `${config.API_URL}/deviceAlarm/`,
	// 	name: "确认报警记录",
	// 	delete: async function(id,data){
	// 		return await http.delete(this.url+id+'/', data);
	// 	}
	// },
}